"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoHide: {
        type: Boolean,
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    content: {
        type: [String, Function, Object],
        default: undefined
    },
    callout: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    iframe: {
        type: Boolean,
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    width: {
        type: Number,
        default: undefined
    },
    position: {
        type: String,
        default: undefined
    },
    showAfter: {
        type: Number,
        default: undefined
    },
    showOn: {
        type: String,
        default: undefined
    },
    hideAfter: {
        type: Number,
        default: undefined
    },
    offset: {
        type: Number,
        default: undefined
    },

    // Events
    contentLoad: {
        type: Function,
        default: undefined
    },
    show: Function,
    hide: Function,
    requestStart: {
        type: Function,
        default: undefined
    },
    error: Function
};